export type DataType =
    | 'adjustments'
    | 'allocations'
    | 'availabilities'
    | 'badges'
    | 'contacts'
    | 'clients'
    | 'categories'
    | 'conflicts'
    | 'criterias'
    | 'dashboards'
    | 'features'
    | 'feeds'
    | 'goals'
    | 'links'
    | 'readers'
    | 'locations'
    | 'reports'
    | 'reviews'
    | 'subaccounts'
    | 'tcrs'
    | 'teams'
    | 'users'
    | 'events'
    | 'notes'
    | 'bookings'
    | 'items'
    | 'fields'
    | 'contracts'
    | 'payees'
    | 'devices'
    | 'types'
    | 'subscriptions'
    | 'signatures'
    | 'tasks'
    | 'estimates'
    | 'gifts'
    | 'industries'
    | 'triggers'
    | 'templates'
    | 'sources'
    | 'invoices'
    | 'balances'
    | 'payments'
    | 'charges'
    | 'deposits'
    | 'numbers'
    | 'orders'
    | 'credentials'
    | 'schedules'
    | 'jobs'
    | 'promotions'
    | 'taxcodes'
    | 'records'
    | 'channels'
    | 'lines'
    | 'images'
    | 'lessons'
    | 'editions'
    | 'options'
    | 'packages'
    | 'components'
    | 'conferences'
    | 'events'
    | 'subscribers'
    | 'balances'
    | 'blocks'
    | 'calendars'
    | 'campaigns'
    | 'royalties'
    | 'changes'
    | 'charges'
    | 'members'
    | 'messages'
    | 'tasks'
    | 'teams'
    | 'templates'
    | 'resources'
    | 'requirements'

export const cacheKeyForRecordType = (type: DataType) => {
    if (type === 'devices')
        return 'device' // key devices by deviceId instead of internal id
    else if (type == 'clients') return 'person' // key clients by userId instead of internal id
    return 'id' // key everything else by id
}
